import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconBasketEmpty = ({ t, fill, className, height, width }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 130 130'
    className={className}
    width={width}
    height={height}>
    <title>{t('Empty Basket')}</title>
    <defs>
      <rect id='path-1' width='130' height='130' />
    </defs>
    <g fill='none' fillRule='evenodd'>
      <path d='M64.8196702,7 C52.0552936,7 41.6770436,17.377032 41.6770436,30.1426266 L41.6770436,30.7029218 L26.3791584,30.7029218 C25.1361558,30.7029218 24.0892564,31.653292 23.9668441,32.8950766 L17,111.506925 C17,120.155873 24.7710504,127 34.3450941,127 L95.319216,127 C104.893564,127 112.66431,120.155873 112.66431,111.727084 L105.672496,32.8950766 C105.551302,31.653292 104.528154,30.7029218 103.2614,30.7029218 L87.9622968,30.7029218 L87.9622968,30.1426266 C87.9622968,17.377032 77.5852648,7 64.8196702,7 Z M46.5004542,30.1426266 C46.5004542,20.0332574 54.710301,11.8234106 64.8196702,11.8234106 C74.9290394,11.8234106 83.1388862,20.0332574 83.1388862,30.1426266 L83.1388862,30.7029218 L46.5004542,30.7029218 L46.5004542,30.1426266 Z M101.044275,35.5263324 L107.81593,111.823309 C107.743457,117.548369 102.164866,122.176589 95.2954643,122.176589 L34.3450941,122.176589 C27.4744746,122.176589 21.8958836,117.548369 21.8234106,111.823309 L28.5950649,35.5263324 L41.6770436,35.5263324 L41.6770436,46.6835144 C41.6770436,48.0230462 42.7489127,49.0946107 44.0893579,49.0946107 C45.4285852,49.0946107 46.5004542,48.0230462 46.5004542,46.6835144 L46.5004542,35.5263324 L83.1388862,35.5263324 L83.1388862,46.6835144 C83.1388862,48.0230462 84.2107552,49.0946107 85.5512005,49.0946107 C86.8907323,49.0946107 87.9622968,48.0230462 87.9622968,46.6835144 L87.9622968,35.5263324 L101.044275,35.5263324 Z'
        stroke='#FFF' fill='#BBB' />
      <g fill='#BBB'>
        <g transform='rotate(45 -31.634 105.734)'>
          <rect y='16.5' width='36.667' height='3.667' rx='1.833' />
          <rect transform='rotate(90 18.333 18.333)' y='16.5' width='36.667' height='3.667'
            rx='1.833' />
        </g>
      </g>
    </g>
  </svg>
)

export default Icon(IconBasketEmpty)
